import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import WelcomeComp from "../WelcomeComp"
import { API_URL } from "../../../helpers/app_url";
import axios from "axios"
import Moment from 'react-moment';
import FilterMenu from "./filter-menu";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardHeader
} from "reactstrap"
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from "reactstrap";
import ElChart from "../insight-chart/charts/el-chart";
class LeadTimeLine extends Component {
  constructor(props) {
    super(props)
    this.state = {
      leads:[],
        isMobile: window.innerWidth < 768,
    }
   
  }
  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer '+token;
   
    axios.get(API_URL + 'Lead/allforagent',{ params: {
       agentId: parseInt(localStorage.getItem("userId"))
    }, headers: { Authorization: str } })
      .then(res => {
        this.setState({ leads: res.data  });
      })

      window.addEventListener("resize", () => {
        this.setState({ isMobile: window.innerWidth < 768 });
        });
}
  
  realtorDate(isoDate) {
    const date = new Date(isoDate);
    return new Date(isoDate).toLocaleDateString('en-US', { month: '2-digit', year: 'numeric' });
  }
  render() {
    const { leads } = this.state;
    
    const lanes = [];
    const cards = [];
    const Dates = []
    var dateObj = new Date();

    const brColor = [{borderBottom:'3px solid #0D6EFD'},{borderBottom:'3px solid #198754'},{borderBottom:'3px solid #0DCAF0'}, {borderBottom:'3px solid #AB2E3C'},{borderBottom:'3px solid #FFC107'}, {borderBottom:'3px solid #000'}];


      var dateStrings = [];
      var dateFormatOptions = {
        month: 'numeric',
        year: 'numeric'
      };
      var HeaddateFormatOptions = {
        month: 'long',
        year: 'numeric'
      };
      dateStrings.push({
        "title": 'No Follow Up',
        "leads" : leads.filter(d => d.nextFollowup === null)
       });
       for (let i = 0; i < 5; ++i) {
        const formattedDate = dateObj.toLocaleDateString('en-US', { month: '2-digit', year: 'numeric' });
      
        dateStrings.push({
          "title": dateObj.toLocaleString('en-US', HeaddateFormatOptions),
          "leads": leads.filter(d => 
            d.nextFollowup && this.realtorDate(d.nextFollowup) === formattedDate
          )
        });
      
        dateObj.setMonth(dateObj.getMonth() + 1);
      }
   //expectedClosing
    
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);


  const renderMobileDateAccordion = () => {
  return (
    <Accordion
      open={this.state.openDate}
      toggle={(id) =>
        this.setState({
          openDate: this.state.openDate === id ? null : id,
        })
      }
    >
      {dateStrings.map((dateString, index) => (
        <AccordionItem key={dateString.title}>
          <AccordionHeader
            targetId={dateString.title}
            style={brColor[index]} // same header styling
          >
            {dateString.title} 
            {/* ({dateString.leads.length}) */}
          </AccordionHeader>

          <AccordionBody accordionId={dateString.title}>
            {dateString.leads.map((lead) => {
              const leadQualificationPoints = lead?.leadQualificationPoints;
              const formattedPoints = leadQualificationPoints ? Math.round(leadQualificationPoints) : 0; 
              let seriesData = [formattedPoints > 0 ? formattedPoints : 0];

              return (
                <Card className="custom-card mt-2" key={lead.id}>
                  <CardBody>
                    <div className="float-end ms-2">
                      <span className="badge rounded-pill badge-soft-success font-size-12">
                        {lead.leadStatusId
                          ? localization["LeadStatus_" + lead.leadStatusId]
                          : "N/A"}
                      </span>
                    </div>
                    <h5 className="card-title mb-2 lead-box-title">
                      <Link to={`/lead/lead-detail/${lead.id}/${lead.leadId}`}>
                        {lead.firstName} {lead.lastName}
                      </Link>
                    </h5>
                    <div className="mt-1">
                      <i className="bx bx-calendar align-middle"></i> :{" "}
                      {lead.lastActivity ? (
                        <Moment format="D MMM YY">{lead.lastActivity}</Moment>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="mt-1">
                      <i className="bx bx-run align-middle"></i> :{" "}
                      {lead.lastActivityType || "No Activity"}
                    </div>
                  </CardBody>
                </Card>
              );
            })}
          </AccordionBody>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
    return (
      <React.Fragment>
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Lead Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">
           
          {/* <Row className="project-header">
            <Col xl="7">
             <Breadcrumbs
              title={this.props.t("Lead")}
              breadcrumbItem={this.props.t("Follow Up View")}
            />
            </Col>
            <Col xl="5">
            <WelcomeComp />
            </Col>
            </Row> */}
             <Card className="card-without-border">
              <CardHeader className="">
                   <FilterMenu />
              </CardHeader>
            </Card>
            <Row>
                  <Col sm="12">
                    <Card>
                      <CardBody>
                          {this.state.isMobile ? (
                            renderMobileDateAccordion()
                            ) : (
                              <>
                        <Row className="toHeadingRow ">
                        { dateStrings.map((dateString , index) => 
                            <Col sm="2" className="" key={dateString.title}>
                                <div className="topHeading" style={brColor[index]}>
                                <span className="sc-kEqXSa CIzYb">{dateString.title}</span>
                                  
                                </div>
                            </Col>
                         )}   
                        </Row>
                       <Row className="toRowContect">
                        { dateStrings.map(dateString => 
                        <Col sm="2" className=" " key={dateString.title}>
                           { dateString.leads.map((lead) => {

                                const leadQualificationPoints = lead?.leadQualificationPoints;
                                const formattedPoints = leadQualificationPoints ? Math.round(leadQualificationPoints) : 0; 
                                let seriesData = [];
                                if (formattedPoints > 0) {
                                  seriesData.push(formattedPoints);
                                } else {
                                  
                                  seriesData.push(0);  
                                }
                                return (
                                  <div className="container p-0" key={lead.id} style={{marginTop:10}}>
                                  <div className="mb-3 card custom-card">
                                   
                                    <div className="card-body">
                                    <div className="float-end ms-2"><span className="badge rounded-pill badge-soft-success font-size-12">{ lead.leadStatusId  ? localization["LeadStatus_"+ lead.leadStatusId]  : 'N/A' }</span></div>
                                      <div className="d-flex align-items-center">
                                        <h5 className="card-title mb-2 lead-box-title"><Link to={"/lead/lead-detail/" + lead.id + "/" + lead.leadId }>{lead.firstName + " "+ lead.lastName}</Link></h5>
                                       
                                      </div>
                                       <div className="mt-1">
                                        <i className="bx bx-calendar align-middle"></i> :  {lead.lastActivity ? <Moment format="D MMM YY">{lead.lastActivity}</Moment> : ''} 
                                        </div>
                                        <div className="mt-1">
                                        <i className="bx bx-run align-middle"></i> : {lead.lastActivityType ? lead.lastActivityType : 'No Activity'}
                                        </div>
                                     
                                      {/* <div className="row pt-1">
                                            <div className="col-3 p-0">
                                              <ElChart series={seriesData} />
                                            </div>
                                            <div className="col-4 p-0">
                                            <span className="line-79">Eligibility</span>
                                            </div>
                                            <div className="col-4">
                                              <Link className="float-end line-79" to={`/lead/lead-detail/${lead.id}/${lead.leadId}`}>
                                                <i className="bx bx-link-external font-size-20"></i>
                                              </Link>
                                            </div>
                                          </div> */}
                                  </div>
                                </div>
                              </div>
                                  );
                                })} 
                                                               
                            </Col>
                         )}   
                           
                        </Row> 
                         </>
                            )}



                      </CardBody>
                    </Card>
                  </Col>
                </Row>  
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
LeadTimeLine.propTypes = {
  t: PropTypes.any,


}
export default connect()(withTranslation()(LeadTimeLine))
